<app-header-one [class]="'header-gym'"></app-header-one>
<app-subheader [title]="'Ordina a domicilio'"></app-subheader>
<app-separator  [size]="'lg'"></app-separator>
<!--section class="p-0 gym-slider">
    <h1>Ordina a domicilio</h1>
    <div class="container border-0 text-center">
        <p *ngIf="location">{{ location.description }}</p>
        <button class="btn btn-solid btn-block btn-sm mx-auto mt-4 w-auto btn-outline" (click)="editLocation()">Modifica</button>
        <a (click)="openAllegerni()">Informazioni sugli allergeni</a>
    </div>
</section-->
<!-- section start -->
<section class="section-b-space pt-0">
    <div class="collection-wrapper">
        <div class="container py-5">
            <div class="row mt-5">
                <div class="col-lg-4">
                    <owl-carousel-o [options]="ProductDetailsMainSliderConfig" #owlCar class="product-slick">
                        <ng-container *ngFor="let image of gallery; index as i">
                            <ng-template carouselSlide [id]="i">
                                <div>
                                    <img [defaultImage]="'assets/images/product/placeholder-header.jpg'"
                                        [lazyLoad]="image" [alt]="image.alt" class="img-fluid">
                                </div>
                            </ng-template>
                        </ng-container>
                    </owl-carousel-o>
                    <div class="media eit-allergeni c-pointer" (click)="openAllegerni()">
                        <img class="img-fluid w-auto" style="max-height: 28px; margin: 0 4px;" src="assets/images/Icone/info.png" alt="">
                        <div class="media-body align-self-center">
                            <h6 class="ml-3 product-title">Informazioni sugli allergeni</h6>
                        </div>
                        <button type="button" class="btn align-self-center" data-type="plus"></button>
                    </div>
                    <!--div *ngIf="location" class="media" (click)="editLocation()">
                        <img class="img-fluid w-auto" style="max-height: 36px;" src="assets/images/posizione.png" alt="">
                        <div class="media-body align-self-center">
                            <h6 class="ml-3 product-title" *ngIf="location.description">{{ location.description }}</h6>
                            <h6 class="ml-3 product-title" *ngIf="!location.description" style="color: red !important;">Inserisci un indirizzo</h6>
                        </div>
                        <button type="button" class="btn align-self-center"
                            data-type="plus">
                            Modifica
                        </button>
                    </div-->
                </div>
                <div class="col-lg-8">
                    <div class="row ml-5">
                        <!--div class="col-3"><img alt="" style="max-width: 100%" [src]="themeLogo"></div-->
                        <div class="col-9">
                            <h1 class="eit-act-title">
                                {{restaurant.name}}
                            </h1>
                            <!--p class="eit-act-descr">
                                <span
                                    *ngIf="typeService.ALL==restaurant.service_type && restaurant.abilitaserviziotavoli == 1">Ordina
                                    a domicilio, ritira al locale</span>
                                <span
                                    *ngIf="typeService.ALL==restaurant.service_type && restaurant.abilitaserviziotavoli == 0">Ordina
                                    a domicilio oppure ritira al locale</span>
                                <span *ngIf="typeService.AWAY==restaurant.service_type">Ritira al locale</span>
                                <span *ngIf="typeService.DELIVERY==restaurant.service_type">Ordina a domicilio</span>
                            </p-->
                            <p class="eit-act-descr mt-3">
                                {{restaurant.descr}}
                            </p>
                        </div>
                    </div>
                    <div>
                        <owl-carousel-o [options]="ProductDetailsMainSliderConfig" >
                            <ng-container *ngFor="let image of promozioni; index as i">
                                <ng-template carouselSlide [id]="i">
                                    <div  class="promo-slide" [ngStyle]="{'background-image': 'url(assets/images/promo-red-long.png)'}">
                                       <h5>{{image.descr}}</h5><h6>{{image.descr_long}}</h6>
                                    </div>
                                </ng-template>
                            </ng-container>
                        </owl-carousel-o>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <app-menu-box [list]="list" id="collapseMenu" [ngbCollapse]="isCollapsedMenu">
            </app-menu-box>
        </div>
    </div>
</section>
<app-footer-two [class]="'bg-img-gym bg-size'"></app-footer-two>
<app-custom-modal #customModal></app-custom-modal>